import AdminExpenseGraph from "../components/AdminExpenseGraph";
import CompletedVouchers from "../components/completedVouchers";
import AdminREjectedVoucher from "../components/AdminREjectedVoucher";
import AdminPEndingVouchers from "../components/AdminPEndingVouchers";
import Context from "../store/Context";
import axios from "axios";
// import Context from "../store/Context";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { RotatingSquare } from "react-loader-spinner";
const AdminHome = () => {
  const [data, setData] = useState([]);
  const connectionUrl = process.env.REACT_APP_BACKEND_URL;
  const ctx = useContext(Context);
  const allVoucherData = ctx.allVoucherData;
  const [open, setOpen] = useState(true);
  const user = JSON.parse(localStorage.getItem("token"));
  const [loadingPendingDAta, setLoadingPendingData] = useState(false);
  const [PendingVouchers, setPendingVouchers] = useState([]);
  const [AcceptedVouchers, setAcceptedVouchers] = useState([]);
  const [RejectedVouchers, setRejectedVouchers] = useState([]);
 
  useEffect(() => {
    async function fetchPendingData() {
      try {
        const response = await axios.post(
          `${connectionUrl}/admin/allPendingVoucher`,
          {
            token: user.access_token,
            domain: user.domain,
          }
        );

        const res = response.data.userData;
        if (response?.data?.userData) {
          ctx.AllVoucher(response.data.userData);
          setPendingVouchers(response.data.userData);
        }
        setLoadingPendingData(true);
      } catch (err) {
        console.log(err);
        toast.error("something went wrong while getting data");
      }
    }
    fetchPendingData();
  }, [ctx.loginData, ctx.trigger]);
  useEffect(() => {
    async function fetchAcceptedData() {
      try {
        const response = await axios.post(
          `${connectionUrl}/admin/allAcceptedVoucher`,
          {
            token: user.access_token,
            domain: user.domain,
          }
        );

        const res = response.data.userData;
        if (response?.data?.userData) {
          setAcceptedVouchers(response.data.userData);
          ctx.AllVoucher(response.data.userData);
        }
        setLoadingPendingData(true);
      } catch (err) {
        console.log(err);
        toast.error("something went wrong while getting data");
      }
    }
    fetchAcceptedData();
  }, [ctx.loginData, ctx.trigger]);
  useEffect(() => {
    async function fetchRejectedData() {
      try {
        const response = await axios.post(
          `${connectionUrl}/admin/allRejectedVoucher`,
          {
            token: user.access_token,
            domain: user.domain,
          }
        );

        const res = response.data.userData;
        if (response?.data?.userData) {
          setRejectedVouchers(response.data.userData);
          ctx.AllVoucher(response.data.userData);
        }
        setLoadingPendingData(true);
      } catch (err) {
        console.log(err);
        toast.error("something went wrong while getting data");
      }
    }
    fetchRejectedData();
  }, [ctx.loginData, ctx.trigger]);
  // const [vouchers, setVouchers] = useState({
  //   pending: [],
  //   accepted: [],
  //   rejected: [],
  // });
  // useEffect(() => {
  //   const pending = [];
  //   const accepted = [];
  //   const rejected = [];

  //   allVoucherData?.forEach((current) => {
  //     console.log(current);
  //     if (current.status === "Pending") {
  //       pending.push(current);
  //     } else if (current.status === "Accepted") {
  //       accepted.push(current);
  //     } else if (current.status === "Rejected") {
  //       rejected.push(current);
  //     }
  //   });

  //   setVouchers({ pending, accepted, rejected });
  // }, [allVoucherData]);
  // const allData = [...allVoucherData];
  // console.log(vouchers);
  const searchItemAccceptedHandler = () => {
    // fetchAcceptedData();
  };
  return (
    <>
      {!loadingPendingDAta && (
        <div className="flex flex-col justify-center items-center  h-[calc(100vh-120px)] w-[100%] font-bold text-[1.2rem]">
          <RotatingSquare
            visible={true}
            height="100"
            width="100"
            color="#2980b9"
            ariaLabel="rotating-square-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
          <p>fetching tour vouchers ...</p>
        </div>
      )}
      {loadingPendingDAta && (
        <section className="main-content  h-[calc(100%-10px)] flex-1 bg-white pt-5 md:pt-3 md:mt-2 pb-24 md:pb-5 ">
          <div className="flex flex-col min-[689px]:flex-row  mx-2 min-[1000px]:mx-12">
            {/* <div className=" w-[100%]  min-[689px]:w-[40%]  h-[65vh] min-h-[400px]  min-[689px]:m-2 my-2 bg-[white] rounded-lg shadow-md shadow-gray-700 text-center ">
              {" "}
              <AdminExpenseGraph></AdminExpenseGraph>
            </div> */}
          </div>{" "}
          <AdminPEndingVouchers
            pending={PendingVouchers}
          ></AdminPEndingVouchers>
          {/* <div className="flex flex-col min-[689px]:flex-row  mx-2 min-[1000px]:mx-12"> */}
          <CompletedVouchers
            accepted={AcceptedVouchers}
            searchItem={searchItemAccceptedHandler}
          ></CompletedVouchers>
          <AdminREjectedVoucher
            rejected={RejectedVouchers}
          ></AdminREjectedVoucher>
          {/* </div> */}
        </section>
      )}
    </>
  );
};

export default AdminHome;
